import type * as React from 'react'

export type PostTag = 'release' | 'post' | 'milestone'

export type Post = {
  slug: string
  title: string
  date: string
  tag: PostTag
  summary: string
  author?: string
  Component: () => Promise<{ default: () => React.JSX.Element }>
}

type MdxFrontmatter = {
  title: string
  date: string | Date
  tag: PostTag
  summary?: string
  author?: string
}

type MdxModule = {
  frontmatter: MdxFrontmatter
  default: () => React.JSX.Element
}

const modules = import.meta.glob('/src/content/news/*.mdx', {
  eager: true,
}) as Record<string, MdxModule>

const lazyModules = import.meta.glob('/src/content/news/*.mdx') as Record<
  string,
  () => Promise<{ default: () => React.JSX.Element }>
>

function slugFromPath(p: string): string {
  return p.split('/').pop()!.replace(/\.mdx$/, '')
}

function normalizeDate(d: string | Date): string {
  if (d instanceof Date) return d.toISOString().slice(0, 10)
  return String(d)
}

const POSTS: Post[] = Object.entries(modules).map(([path, mod]) => {
  const fm = mod.frontmatter
  return {
    slug: slugFromPath(path),
    title: String(fm.title),
    date: normalizeDate(fm.date),
    tag: fm.tag as PostTag,
    summary: String(fm.summary ?? ''),
    author: fm.author ? String(fm.author) : undefined,
    Component: lazyModules[path],
  }
})

POSTS.sort((a, b) => (a.date > b.date ? -1 : 1))

export function listPosts(opts: { tag?: PostTag } = {}): Post[] {
  if (!opts.tag) return POSTS
  return POSTS.filter((p) => p.tag === opts.tag)
}

export function getPost(slug: string): Post | undefined {
  return POSTS.find((p) => p.slug === slug)
}
